module.exports = __webpack_public_path__ + "img/26.87263399.png";